import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./root";
import { ApiDocsView } from "../features/api-docs/ApiDocsView";

export type ApiDocsSearch = { fullscreen?: true };

export const apiDocsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/api-documentation",
  validateSearch: (search: Record<string, unknown>): ApiDocsSearch => {
    const fs = search.fullscreen;
    const on = fs === true || fs === "true" || fs === 1 || fs === "1";
    return on ? { fullscreen: true } : {};
  },
  component: ApiDocsView,
});
